import { render, staticRenderFns } from "./FreightTableRouteFaixas.vue?vue&type=template&id=7b8b7021&scoped=true"
import script from "./FreightTableRouteFaixas.vue?vue&type=script&lang=js"
export * from "./FreightTableRouteFaixas.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRouteFaixas.vue?vue&type=style&index=0&id=7b8b7021&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b7021",
  null
  
)

export default component.exports